import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ShadowlessInputEl } from "common/components/input";
import { InvisibleSubmit } from "common/templates/mixins";
import { AuthContainerEl } from "common/widgets/auth-container";
import { ValidationStatus } from "common/components/input/types";
import { TwoFactorStep } from "../validation";
import { QrCodeEl } from "./qr-code";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(AuthContainerEl, { attrs: { "show-footer-links": true } }, /* @__PURE__ */ jsx(
    "div",
    {
      class: { "verify-auth-form": this.attr(`step`) === TwoFactorStep.Verify },
      sel: ".auth-form",
      attrs: { slot: `auth-form-slot` }
    },
    /* @__PURE__ */ jsx(
      "form",
      {
        attrs: {
          action: `/security/twofactor/verify/totp/`,
          method: `post`
        },
        hook: {
          insert: this.helpers.onInsert
        }
      },
      this.attr(`step`) === TwoFactorStep.Verify ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("h1", { sel: ".auth-form-title" }, "Two-Factor Authentication"), /* @__PURE__ */ jsx("div", { sel: ".auth-form-subtitle" }, "Enter the verification code from your authentication app to log in.")) : /* @__PURE__ */ jsx(QrCodeEl, null),
      /* @__PURE__ */ jsx("div", { sel: ".input-container" }, /* @__PURE__ */ jsx(
        ShadowlessInputEl,
        {
          attrs: {
            "auto-focus": true,
            "field-name": `totp_code`,
            label: `Enter Verification Code`,
            placeholder: `e.g. 239467`,
            "validation-status": this.attr(`error`) !== `null` && this.attr(`error`).length > 0 && this.state.formInputEmpty && ValidationStatus.Invalid,
            "error-message": this.attr(`error`) !== `null` && this.attr(`error`).replaceAll(`"`, ``)
          },
          on: { input: this.helpers.setIsFormValueEmpty }
        }
      ), /* @__PURE__ */ jsx("div", { sel: ".auth-form-field-row" }, /* @__PURE__ */ jsx(
        "input",
        {
          attrs: {
            type: `hidden`,
            name: `csrfmiddelwaretoken`,
            value: this.helpers.getCsrfToken()
          }
        }
      ), /* @__PURE__ */ jsx(
        ButtonEl,
        {
          attrs: {
            theme: ButtonTheme.Primary
          },
          on: {
            click: this.helpers.submitForm
          }
        },
        this.attr(`step`) === TwoFactorStep.Verify ? `Log In` : `Enable Authentication App`
      ), /* @__PURE__ */ jsx(
        ButtonEl,
        {
          sel: ".back-btn",
          attrs: {
            theme: ButtonTheme.Secondary
          },
          on: {
            click: this.helpers.handleClickBackButton
          }
        },
        "Back"
      )), this.attr(`step`) === TwoFactorStep.Verify && /* @__PURE__ */ jsx("a", { sel: ".recovery-code-page-prompt", attrs: { href: `/security/twofactor/verify/recovery-code` } }, "Need help? Use a recovery code to sign in.")),
      InvisibleSubmit()
    )
  )));
}
